import { vars } from '@app/config'

import { hasCookie } from './hasCookie'
import { isBuyerTokenMode } from './isBuyerTokenMode'
import { isBuyerView } from './isBuyerView'

export const isStaffTokenModeInBuyerView = () =>
  isBuyerView() &&
  !isBuyerTokenMode() &&
  (hasCookie(vars.b2b_access_token) || hasCookie(vars.b2b_refresh_token))
